import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import React, { useEffect, useState } from "react";
import '../../../../cssfiles/homepage.css';
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import { useSelector } from 'react-redux';

const rows_asset_status_table = [
    ['AHU', '1', 'JHS713L203', 'Connected', '2024-05-27 15:04:11'],
    ['Chiller', '2', 'JHS713L204', 'Connected', '2024-05-27 15:10:40'],
    ['ETS', '3', 'JHS713L205', 'Disconnected', '2024-05-21 13:26:57'],
    ['Plating Planet', '4', 'JHS713L206', 'Connected', '2024-05-28 08:09:37'],
    ['Compressor Panel', '5', 'JHS713L207', 'Connected', '2024-05-28 08:30:45'],
    ['M.Lighting Panel', '6', 'JHS713L208', 'Connected', '2024-05-28 10:25:19'],
    ['Press Shop', '7', 'JHS713L209', 'Disconnected', '2024-05-21 19:53:05'],
]

export default function Tablewidgetrealtime(props){
    //console.log("IN Tablewidget I AM IN");
    const livedata = useSelector((state) => state.mainpagedata.livedata);
    {console.log("inside Tablewidgetrealtime props.widgetprop.props.extended.",livedata)}
    
    //{console.log("inside Tablewidget props.widgetprop.widgetname.",props.widgetprop.widgetname)}
    //{console.log("inside Tablewidget props.widgetprop.type.",props.widgetprop.type)}
    /*
    const rows = [
        createData('Baseline Target','9000.00' ),
        createData('Yearly Target', '8000.00'),
        createData('Yearly Consumption', '3200.00'),
        createData('This Months Target', '666.66'),
        createData('This Months Deviation', '0.00'),
        createData('Months Asking Rate', '533.00'),
        createData('Todays Consumption', '16.66'),
    ];
    function createData(  name,  value,  ) {
        return { name, value, };
    }
    */
    const filter = useSelector((state) => state.mainpagedata.filter)
    //const [assetStatusTableRows, setAssetStatusTableRows] = useState(rows_asset_status_table)
    const tagcollectionvalue = useSelector((state) => state.mainpagedata.tagcollectionvalues)
    const tagdetailsobject= useSelector((state) => state.mainpagedata.tagdetailsobject)
    //console.log("Tablewidget insi**********************tagcollectionvalue******************** in realtable",tagdetailsobject)
    const sdate_edate_selected = useSelector((state) => state.mainpagedata.selecteddates)
    
    var dataobject = {};
    
    //Generic variables
    const [table_head, setTableHead] = useState([]);
    const [table_rows, setTableRows] = useState([]);


    useEffect(() => { 
        
        var head_values = props.widgetprop.props.extended.column_categories;
        var tagproperties = props.widgetprop.props.extended.tagprops;
        var rows_values = [];

        console.log("head_values in tablewidgetrealtime ",head_values)
        
        // tagproperties.map((tagprops)=>{
        //     console.log("current tagprops",tagprops)
        //     var rowname = tagprops.tagname;
        //     var tagid = tagprops.tagid;
        //     var singlerowdata = [];
          
        //     rows_values.push(singlerowdata)
        // })

        if(livedata.length) {
            for(let i=0; i<livedata.length; i++) {
                //console.log("value card ",livedata[i].TagId, props.widgetprop.props.extended.tagprops[0].tagid)
                // if(parseInt(props.widgetprop.props.extended.tagprops[0].tagid) === parseInt(livedata[i].TagId)) {
                //     console.log("livedata[i].value ",livedata[i].value)
                //     setValue(livedata[i].value.toFixed(3))
                //     var date = new Date(livedata[i].timestamp * 1000)
                //     var timestamp = (date.getDate() > 9 ? date.getDate() : "0"+date.getDate()) + "-" + (date.getMonth()+1 > 9 ? date.getMonth()+1 : "0"+ date.getMonth()+1) + "-" + date.getFullYear() + " " + (date.getHours() > 9 ? date.getHours() : "0"+date.getHours()) + ":" + (date.getMinutes() > 9 ? date.getMinutes() : "0"+date.getMinutes()) + ":" + (date.getSeconds() > 9 ? date.getSeconds() : "0"+date.getSeconds())
                //     setTime(timestamp)
                // }
                
                for(var j=0;j<tagproperties.length;j++){
                        var singlerowdata = [];
                        if(parseInt(tagproperties[j].tagid) === parseInt(livedata[i].TagId)) {
                            //console.log("livedata[i].value ",livedata[i].value)
                            //setValue(livedata[i].value.toFixed(3))
                            var parameter_name = tagdetailsobject[tagproperties[j].tagid]?.Alias;
                            var parameter_data = livedata[i].value.toFixed(3);
                            var parameter_unit = tagdetailsobject[tagproperties[j].tagid]?.Unit;
                            var date = new Date(livedata[i].timestamp * 1000)
                            var month = date.getMonth()+1;
                            var timestamp = (date.getDate() > 9 ? date.getDate() : "0"+date.getDate()) + "-" + (month > 9 ? month : "0"+ month) + "-" + date.getFullYear() + " " + (date.getHours() > 9 ? date.getHours() : "0"+date.getHours()) + ":" + (date.getMinutes() > 9 ? date.getMinutes() : "0"+date.getMinutes()) + ":" + (date.getSeconds() > 9 ? date.getSeconds() : "0"+date.getSeconds())
                            //setTime(timestamp)
                            singlerowdata.push(parameter_name);
                            singlerowdata.push(parameter_data);
                            singlerowdata.push(parameter_unit);
                            singlerowdata.push(timestamp);

                            rows_values.push(singlerowdata);
                        }
                        
                }

                
        
            }
        }

        console.log("//////rows_values/////////-Tablewidget-rows_values realtime",rows_values,)
        switch(props.widgetprop.widgetname)
        {
            case 'Parameter Data':
                console.log("head_tod_values realtime",head_values)
                console.log("rows_tod_values realtime",rows_values)
                setTableHead(head_values)
                setTableRows(rows_values)
                break
           
        }
    }, [props.widgetprop,livedata]);
        
       
        // function Rows({ row_value }) {
        //     const value = row.split("\n"); 
        // }

        function BreakLine({ value }) {
            const breaklines = value.split("\n");
          
            return (
              <List sx={{padding:'4px 0px 4px 0px'}}>
                {breaklines.map((line, i) => (
                  <ListItem sx={{padding:'2px 0px 2px 0px'}} key={i}>{line}</ListItem>
                ))}
              </List>
            );
          }

          return(
            <>
            {/* console.log("table_rows in initialized",table_rows) */}
            {(table_rows.length > 0 ) && ( 
                
            <TableContainer component={Paper} sx={{ width: '100%', height:"100%",paddingLeft:'0px',backgroundColor:'var(--secondary-backgroundLK)',paddingRight:'0px' }} elevation={0}>
                <Table sx={{ width: '100%' }} size="small">
                    {
                           <TableHead>
                                    <TableRow sx={{border:"0px"}}>
                                    {table_head.map((table_head_value) => 
                                    (
                                        
                                        <TableCell sx={{
                                                        fontSize:props.widgetprop.props.extended.tablehead.fontsize,
                                                        fontWeight:props.widgetprop.props.extended.tablehead.fontweight,color:"var(--grey-variation-tableLK)"
                                                      }}>{table_head_value}
                                                      </TableCell>
                                    ))}
                                    </TableRow>
                            </TableHead>
                            
                        
                    }
                    {console.log("table_rows here",table_rows)}
                    <TableBody>
                        {table_rows.map((row,index) => (
                            <TableRow
                                key={index}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 },height:"9px",'& > *': { borderBottom: "1px solid var(--table-boarder-line)" } }}
                            >   
                                {row.map((row_value, row_index)=>(
                                                                                    
                                                    <TableCell component="th" scope="row" sx={{fontSize:props.widgetprop.props.extended.tablerows.fontsize,
                                                        fontWeight:props.widgetprop.props.extended.tablerows.fontweight,color: (row_value === 'Connected' || row_value === 'ON TARGET') ? '#00943D' : (row_value === 'Disconnected' || row_value === 'DEVIATED BY 3%') ? '#DC272D' : 'var(--grey-variation-tablerowsLK)'}} >
                                                                {/*(row_value.includes('\n'))?<BreakLine value={row_value}/>:row_value*/}
                                                                {row_value}                                                
                                                    </TableCell>        
                                ))}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>)}
            </>
        )
    
}


/*
{(row_index==1 && props.widgetprop.widgetname=='TOD')?<BreakLine value={row_value}/>:row_value}


                                                        {row_value.includes('\n')?<BreakLine value={row_value}/>:row_value}

*/ 